export default __webpack_public_path__ + "static/media/review.e505f166.gif";